var _defs, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdeboelLogoExtendedLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg9",
    xmlSpace: "preserve",
    width: 400,
    height: 100,
    viewBox: "0 0 400 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.50375,
    y: 51.577255,
    width: 290.96299,
    height: 33.07672,
    id: "rect52409"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.78407,
    y: 7.8487129,
    width: 308.90292,
    height: 36.720768,
    id: "rect21317"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.91645,
    y: 28.031118,
    width: 41.626209,
    height: 82.972107,
    id: "rect3565"
  }), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,85.039 H 85.039 V 0 H 0 Z",
    id: "path21"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,113.38587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "matrix(0.97152778,0,0,0.97152778,-12.929781,6.2302396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19",
    clipPath: "url(#clipPath23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(36.109,51.9884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 2.847 c 0.666,0 1.119,0.089 1.359,0.268 0.24,0.178 0.438,0.576 0.593,1.196 L 5.391,3.742 C 5.438,3.92 5.461,4.079 5.461,4.218 5.461,4.52 5.374,4.728 5.2,4.84 5.025,4.952 4.702,5.008 4.229,5.008 H 1.29 Z m -0.686,-2.614 -0.906,-3.521 c -0.101,-0.395 -0.151,-0.817 -0.151,-1.266 0,-0.256 0.05,-0.535 0.151,-0.837 h -7.111 c 0.302,0.449 0.528,0.848 0.68,1.196 0.151,0.349 0.311,0.853 0.481,1.511 l 2.859,11.062 c 0.101,0.38 0.151,0.798 0.151,1.255 0,0.256 -0.05,0.534 -0.151,0.837 H 7.785 c 0.79,0 1.382,-0.049 1.778,-0.145 0.395,-0.098 0.755,-0.277 1.081,-0.541 0.673,-0.565 1.01,-1.293 1.01,-2.185 0,-0.24 -0.062,-0.604 -0.186,-1.092 L 10.736,0.849 C 10.442,-0.414 9.919,-1.332 9.167,-1.906 8.772,-2.2 8.36,-2.392 7.93,-2.48 7.5,-2.57 6.782,-2.614 5.775,-2.614 Z",
    style: {
      fill: "#5a74ac",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(43.7394,29.3419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 3.01 c 0.689,0 1.127,0.091 1.312,0.273 0.186,0.182 0.396,0.71 0.628,1.586 l 1.917,7.414 c 0.07,0.278 0.105,0.491 0.105,0.638 0,0.256 -0.101,0.457 -0.303,0.605 -0.116,0.077 -0.399,0.116 -0.848,0.116 H 2.742 Z m -7.251,-2.615 c 0.31,0.457 0.539,0.858 0.686,1.203 0.147,0.345 0.306,0.847 0.476,1.505 l 2.859,11.062 c 0.101,0.379 0.151,0.798 0.151,1.255 0,0.255 -0.05,0.534 -0.151,0.836 H 8.563 c 0.961,0 1.631,-0.031 2.011,-0.093 0.38,-0.062 0.736,-0.201 1.069,-0.418 0.418,-0.279 0.751,-0.645 0.999,-1.098 0.248,-0.453 0.372,-0.927 0.372,-1.424 0,-0.519 -0.054,-0.983 -0.163,-1.394 L 10.934,1.406 C 10.717,0.507 10.508,-0.143 10.307,-0.546 10.105,-0.949 9.795,-1.333 9.377,-1.697 8.943,-2.084 8.505,-2.334 8.064,-2.446 7.623,-2.559 6.879,-2.615 5.833,-2.615 Z",
    style: {
      fill: "#5a74ac",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "translate(42.5197,7.3898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -26.585,35.13 0,70.259 26.585,35.13 Z M 0,-3.469 29.211,35.13 0,73.729 -29.211,35.13 Z",
    style: {
      fill: "#5a74ac",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path35"
  })))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.75000002,0,0,-0.75000002,0,85.039405)",
    id: "text3563",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 40,
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#rect3565)",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.74894681,0,0,-0.74894681,-32.041173,83.324755)",
    id: "text21315",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 32,
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#rect21317)",
      fill: "#5a74ac",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 129.7832,
    y: 37.04418,
    id: "tspan84099"
  }, "Peter Deboel BVBA"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    transform: "matrix(0.72391566,0,0,-0.72391566,-26.943655,80.223901)",
    id: "text52407",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "21.3333px",
      lineHeight: "125%",
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#rect52409)",
      opacity: 1,
      fill: "#5a74ac",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 129.50391,
    y: 71.041141,
    id: "tspan84103"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontFamily: "Arial",
      InkscapeFontSpecification: "Arial"
    },
    id: "tspan84101"
  }, "Schrijnwerk- &amp; Meubelmakerij")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdeboelLogoExtendedLight);
export default __webpack_public_path__ + "static/media/pdeboel-logo-extended-light.afa1a1ff11fa5ca7128d1cb39df87757.svg";
export { ForwardRef as ReactComponent };